module.exports = __webpack_public_path__ + "img/logo_bw.652bede2.svg";